import {
  Layout,
  Row,
  Col,
  Card,
  Image,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useEffect } from "react";
import fileSVG from "../../../assests/file.svg";

import "./PrivacyAndPolicies.css";
import { useMediaQuery } from "react-responsive";
import BreadcrumbNav from "../../common/bread-crumbs/BreadCrumb";

const { Content } = Layout;
const { Title, Text } = Typography;
const PDF_BASE_URL = "/pdf";
/*
 * WARNING – DO NOT MODIFY
 * The following policy-related PDF entries are intentionally commented out based on product/legal decisions.
 * Do NOT uncomment or add new policy items here unless there is an approved ticket and written confirmation.
 */
const cardItems = [
  {
    icon: fileSVG,
    text: "User Agreement",
    pdfPath: `${PDF_BASE_URL}/AMPUserAgreement.pdf`,
  },
  // {
  //   icon: fileSVG,
  //   text: "Standard Fees Pricing",
  //   pdfPath: `${PDF_BASE_URL}/AMPStandardFeesPricing.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Listing Policies",
  //   pdfPath: `${PDF_BASE_URL}/AMPListingPolicies.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Rules for Buyers",
  //   pdfPath: `${PDF_BASE_URL}/AMPRulesforBuyers.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Seller Performance Standard",
  //   pdfPath: `${PDF_BASE_URL}/AMPSellerPerformanceStandards.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Prohibited and Restricted Items",
  //   pdfPath: `${PDF_BASE_URL}/AMPProhibitedRestrictedItems.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Member to Member Contact",
  //   pdfPath: `${PDF_BASE_URL}/AMPMembertoMemberContact.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Buy Sell Outside",
  //   pdfPath: `${PDF_BASE_URL}/AMPBuySellOutside.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Contact a Seller",
  //   pdfPath: `${PDF_BASE_URL}/AMPContactSeller.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Contacting a Buyer",
  //   pdfPath: `${PDF_BASE_URL}/AMPContactBuyer.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Duplicate Listing Policy",
  //   pdfPath: `${PDF_BASE_URL}/AMPDuplicateListingPolicy.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Member Behavior Policy",
  //   pdfPath: `${PDF_BASE_URL}/AMPMemberBehaviorPolicies.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Retracting a Bid",
  //   pdfPath: `${PDF_BASE_URL}/AMPCancellingCampaignNH.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Report an Item",
  //   pdfPath: `${PDF_BASE_URL}/AMPReportAnItem.pdf`,
  // },
  {
    icon: fileSVG,
    text: "Privacy Notice",
    pdfPath: `${PDF_BASE_URL}/AMPPrivacyNotice.pdf`,
  },
  // {
  //   icon: fileSVG,
  //   text: "Feedback",
  //   pdfPath: `${PDF_BASE_URL}/AMPFeedback.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Credit Application Form",
  //   pdfPath: `${PDF_BASE_URL}/AMPCreditApplicationForm.pdf`,
  // },
  // {
  //   icon: fileSVG,
  //   text: "Unpaid Item",
  //   pdfPath: `${PDF_BASE_URL}/AMPUnpaidItem.pdf`,
  // },
];

const PrivacyAndPolicies = () => {
  const isMobile = useMediaQuery({ maxWidth: 860 });
  const isMobiles = useMediaQuery({ maxWidth: 768 });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="privacy-container">
      <Content className="privacy-content">
        {isMobiles ? (
          <> </>
        ) : (
          <>
            <BreadcrumbNav />
          </>
        )}
        <Row justify="center" className="privacy-header-row">
          <Col span={24}>
            <Title style={{ fontSize: "16px" }}>Privacy & Policies</Title>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          {cardItems?.map((item, index) => (
            <Col key={index} xs={12} sm={12} md={8} lg={6}>
              <a href={item.pdfPath} target="_blank" rel="noopener noreferrer">
                {isMobile ? (
                  <Card className="card-item" hoverable>
                    <Row justify="start">
                      <Col xs={24} sm={6}>
                        <Image
                          preview={false}
                          src={item.icon}
                          height={30}
                          width={40}
                          alt="Frame"
                          className="card-item-icon"
                        />
                      </Col>
                      <Col xs={24} sm={18}>
                        <Text className="card-item-text">{item.text}</Text>
                      </Col>
                    </Row>
                  </Card>
                ) : (
                  //desktop view
                  <Card bordered={false} className="card-item">
                    <Row align="middle" gutter={16}>
                      <Col span={4}>
                        <Image
                          preview={false}
                          src={item.icon}
                          height={30}
                          width={30}
                          alt="Frame"
                          className="card-item-icon"
                        />
                      </Col>
                      <Col span={20}>
                        <div className="privarcypolicy-card-text">
                          {item.text}
                        </div>
                      </Col>
                    </Row>
                  </Card>
                )}
              </a>
            </Col>
          ))}
        </Row>
      </Content>
    </div>
  );
};

export default PrivacyAndPolicies;
